import type { User } from '@paintscout/api'
import type { CalendarEvent } from 'paintscout'
import { removeAuth0Prefix } from '../users'
import { getAvailabilityGaps } from './get-availability-gaps'

export function filterEvents({
  date,
  events,
  selectedUsers,
  users,
  view
}: {
  date: Date
  events: CalendarEvent[]
  selectedUsers: User[]
  users?: User[]
  view: 'month' | 'week' | 'day' | 'agenda'
}): CalendarEvent[] {
  if (!users?.length) {
    return events
  }
  const userEvents = events.filter((event) => {
    return selectedUsers.some((user) => removeAuth0Prefix(user.user_id) === removeAuth0Prefix(event.estimator.id))
  })

  if (selectedUsers.length !== 1 || !['day', 'week'].includes(view)) {
    return userEvents
  }

  // If only one user is selected, we want to include the gaps in their unavailability
  const selectedUser = selectedUsers[0]
  const userAvailability = selectedUser.preferences?.availability

  if (!userAvailability) {
    return userEvents
  }

  const availabilityGaps = getAvailabilityGaps({
    availability: userAvailability,
    date,
    view: view as 'day' | 'week'
  })

  return [...userEvents, ...availabilityGaps]
}
